<app-skeleton-wrapper [loading]="loading">
  <tui-scrollbar *ngIf="!!items?.length; else noDataTmp" class="list-wrapper">
    <div *ngIf="withCounter && items?.length" class="counter">
      <span class="counter__title">{{ 'common.labels.quantity' | translate }}: {{ count ?? items?.length }}</span>
    </div>

    <div class="list">
      <ng-container *ngIf="groupingEnable; else simpleList">
        <div *ngFor="let group of groups" class="group">
          <ng-container *ngIf="group.items.length">
            <div class="group__title">{{ group.title | translate }} ({{ group.items.length }})</div>
            <div class="group__list">
              <ng-container
                *ngTemplateOutlet="
                  list;
                  context: {
                    items: group.items,
                    selectedId: selectedId,
                    itemActions: itemActions
                  }
                "
              ></ng-container>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-template #simpleList>
        <ng-container
          *ngTemplateOutlet="
            list;
            context: {
              items: items,
              selectedId: selectedId,
              itemActions: itemActions
            }
          "
        ></ng-container>
      </ng-template>

      <ng-template #list let-items="items" let-selectedId="selectedId" let-itemActions="itemActions">
        <div *ngFor="let item of items">
          <button
            type="button"
            class="list__item"
            [class.list__item_selected]="selectedId === item.id"
            (click)="onToggleItem(item)"
          >
            <ng-container *ngIf="itemContentTmp; else simpleTmp">
              <ng-container *ngTemplateOutlet="itemContentTmp; context: { $implicit: item }"></ng-container>
            </ng-container>

            <ng-container *ngIf="itemActions?.length">
              <ng-container *ngFor="let itemAction of itemActions">
                <ng-container *ngIf="itemAction.isVisible && itemAction.isVisible(item)">
                  <app-icon
                    *ngIf="itemAction.icon; else textLink"
                    class="list__action-button"
                    [ngClass]="'list__action-button_' + itemAction.type"
                    [src]="itemAction.icon"
                    [size]="'20px'"
                    [tuiHint]="itemAction.title"
                    (click)="$event.stopPropagation(); itemAction.clickCallback(item)"
                  ></app-icon>

                  <ng-template #textLink>
                    <app-link
                      class="list__action-link"
                      [ngClass]="'list__action-link_' + itemAction.type"
                      [displayText]="itemAction.title"
                      (click)="$event.stopPropagation(); itemAction.clickCallback(item)"
                    ></app-link>
                  </ng-template>
                </ng-container>
              </ng-container>
            </ng-container>
          </button>

          <div class="list__divider"></div>
        </div>
      </ng-template>
    </div>

    <div
      *ngIf="items && count && items.length < count"
      waIntersectionObserver
      (waIntersectionObservee)="onIntersection($event)"
    >
      <app-loader-wrapper [loading]="true"></app-loader-wrapper>
    </div>
  </tui-scrollbar>
</app-skeleton-wrapper>

<ng-template #simpleTmp let-item="item">
  <new-list-item-birthdays-user [user]="item"></new-list-item-birthdays-user>
</ng-template>

<ng-template #noDataTmp>
  <div *ngIf="!items?.length" class="list__no-data">
    <span class="tui-text_body-m">
      {{ 'common.labels.noData' | translate }}
    </span>
  </div>
</ng-template>
